module.exports = {
  "7030.common.7030": "هفتادسی",
  "7030.common.percent": "درصد",
  "7030.common.each": "هر",
  "7030.common.new": "جدید",
  "7030.common.notifs": "اعلانات",
  "7030.comment.replay": "پاسخ",
  "7030.common.add": "افزودن",
  "7030.common.from": "از",
  "7030.common.delete": "حذف",
  "7030.common.price": "مبلغ",
  "7030.common.priceTooman": "(تومان) مبلغ",
  "7030.common.save": "ذخیره",
  "7030.common.set": "ثبت",
  "7030.common.cancel": "انصراف",
  "7030.common.message": "پیام",
  "7030.common.deleteFrom": "حذف از",
  "7030.common.continue": "ادامه",
  "7030.common.unitPrice": "تومان",
  "7030.common.success": "موفق",
  "7030.common.failed": "ناموفق",
  "7030.common.Netsuccess": "پرداخت موفق اینترنتی",
  "7030.common.Netfailed": "پرداخت ناموفق اینترنتی",
  "7030.common.successPayment": "پرداخت با موفقیت انجام شد",
  "7030.common.count": "عدد",
  "7030.common.all": "همه",
  "7030.common.card": "کارت",
  "7030.common.sort": " ترتیب نمایش",
  "7030.common.default": "پیش فرض",
  "7030.common.showAll": "نمایش همه",
  "7030.common.select": "انتخاب",
  "7030.common.filter": "اعمال فیلتر",
  "7030.common.paymentStatus": "وضعیت پرداخت",
  "7030.common.sendRequest": "ارسال درخواست",
  "7030.common.requestSubmited": ".درخواست شما با موفقیت ثبت شد",
  "7030.common.saveChanges": "ذخیره تغییرات",
  "7030.common.messages": "پیام‌ها",
  "7030.common.transaction": "تراکنش‌ها",
  "7030.common.transactionId": "شماره تراکنش",
  "7030.income.backToYourCredit": "بازگشت به اعتبار شما از این خرید",
  "7030.income.choosePaymentWay": "روش پرداخت خود را انتخاب کنید",
  "7030.common.addCredit": "افزایش اعتبار",
  "7030.common.deficit": "کسری",
  "7030.common.share": "اشتراک",
  "7030.common.income": "کسب درآمد",
  "7030.common.profile": "پروفایل",
  "7030.common.vitrin": "ویترین",
  "7030.common.specialSuggestions": "پیشنهادات ویژه",
  "7030.common.update": "بروزرسانی",
  "7030.common.newVersion": "تغییرات جدید",
  "7030.common.updateDesc": "نسخه جدید بارگذاری شده است.",
  "7030.common.downloading": "بارگذاری نسخه‌ی جدید",
  "7030.common.moreInfo": "اطلاعات بیشتر",
  "7030.common.more": "بیشتر",
  "7030.common.charge": "شارژ",
  "7030.common.cantDetectopr": "اپراتور تشخیص داده نشد لطفاً اپراتور خود را انتخاب کنید",
  "7030.common.internet": "اینترنت",
  "7030.common.internetPackageName": "نام بسته",
  "7030.common.bill": "قبض",
  "7030.common.billInquiry": "پرداخت قبض",
  "7030.common.cardToCard": "انتقال وجه",
  "7030.common.transform": "سفر",
  "7030.common.transformTicket": "بلیت سفر",
  "7030.common.charity": "نیکوکاری",
  "7030.common.VIPs": "وی آی پی‌ها",
  "7030.common.credit": "موجودی",
  "7030.common.car": "خودرو",
  "7030.common.carInquiry": "خدمات خودرو",
  "7030.common.carInquiryLast": "استعلامات من",
  "7030.common.insurance": "بیمه",
  "7030.common.searchResult": "نتایج جستجو",
  "7030.common.ordePreview": "بازبینی سفارش",
  "7030.common.compeletPurchaceInfo": "تکمیل اطلاعات خرید",
  "7030.common.compeletTheInfo": "تکمیل اطلاعات",
  "7030.common.PurchaceDetailes": "مشخصات خرید",
  "7030.common.carInsurance": "بیمه خودرو",
  "7030.common.milionToman": "میلیون تومان",
  "7030.common.cover": "پوشش",
  "7030.common.billWithCode": "قبض با شناسه",
  "7030.common.myInformation": "اطلاعات من",
  "7030.common.payBillWithCode": "پرداخت قبض با شنا..",
  "7030.common.increase": "افزایش اعتبار",
  "7030.common.getWallet": "برداشت وجه",
  "7030.common.ticket": "بلیت",
  "7030.common.rahvar": "پلیس راهور",
  "7030.common.inquiry": "پلیس راهور",
  "7030.common.priceLabel": "مبلغ پرداختی",
  "7030.common.score": "امتیاز",
  "7030.common.pay": "پرداخت",
  "7030.common.call": "تماس",
  "7030.common.dial": "شماره‌گیری",
  "7030.common.copyCode": "کپی کد",
  "7030.common.copy": "کپی",
  "7030.common.submit": "تایید",
  "7030.common.otpPlaceHolder": "کدتایید را وارد کنید",
  "7030.common.otpLabel": "کدتایید را وارد کنید",
  "7030.common.yes": "بله",
  "7030.common.no": "خیر",
  "7030.common.readMore": "ادامه مطلب",
  "7030.common.readLess": "بستن مطلب",
  "7030.common.doYouExite": "آیا میخواهید خارج شوید؟",
  "7030.common.waiteAMoment": "لطفاًً کمی صبر کنید...",
  "7030.common.payWithCredit": "پرداخت با اعتبار",
  "7030.common.bank": "نام بانک",
  "7030.common.increaseCredit": "افزایش اعتبار",
  "7030.common.del": "آیا از حذف @param مطمئنید؟",
  "7030.common.order": "سفارش",
  "7030.common.dontSupportShare": "قابلیت اشتراک گذاری در مرورگر شما پشتیبانی نمی‌شود.",
  "7030.common.reset": "بازنشانی",
  "7030.common.resetSettings": "بازنشانی تنظیمات",
  "7030.common.chooseDate": "لطفاً تاریخ مورد نظر را انتخاب کنید",
  "7030.common.supperApp": "سوپر اپلیکیشن هفتادسی",
  "7030.common.yourInviteLink": "لینک دعوت شما در سامانه هفتادسی",
  "7030.common.invitationCopy": "کپی دعوتنامه",
  "7030.common.errorPleaseRepeat": "خطایی رخ داده است لطفاً دوباره امتحان کنید!",
  "7030.common.send": "ارسال",
  "7030.common.copied": "کپی شد!",
  "7030.common.registerAndContinue": "تایید و ادامه",
  "7030.common.dnlRecipt": "دانلود فاکتور",
  "7030.common.dnlReciptSec": "دانلود رسید",
  "7030.common.addIcomeToWalletFinished": "انتقال سود به کیف پول کاربری با موفقیت انجام شد.",
  "7030.common.infoCopied": "اطلاعات با موفقیت کپی شد!",
  "7030.common.showMore": "نمایش بیشتر",
  "7030.common.showLess": "نمایش کمتر",
  "7030.common.infoSaved": "اطلاعات با موفقیت ذخیره شد!",
  "7030.common.infoDeleted": "اطلاعات با موفقیت حذف شد!",
  "7030.common.deletedSuccesfully": "با موفقیت حذف شد!",
  "7030.common.commingSoon": "به زودی",
  "7030.common.mobileOwnerName": "نام دارنده شماره همراه",
  "7030.common.nothingHasRegistered": "هیچ @param ثبت نکرده اید",
  "7030.common.addingNewThings": "افزودن @param جدید",
  "7030.common.post": "پست",

  "7030.common.12Month": "12 ماهه",
  "7030.common.theMonth": "ماهه",
  "7030.common.trackingCode": "کد رهگیری",
  "7030.common.deletTitle": "مطمئن هستید؟",

  "7030.vitrin.shop": "فروشگاه هفتادسی",
  "7030.vitrin.otherProduct": "سایر محصولات",
  "7030.vitrin.shopCenter": "فروشگاه‌ها",
  "7030.month.January": "دی",
  "7030.month.February": "بهمن",
  "7030.month.March": "اسفند",
  "7030.month.April": "فروردین",
  "7030.month.May": "اردیبهشت",
  "7030.month.June": "خرداد",
  "7030.month.July": "تیر",
  "7030.month.August": "مرداد",
  "7030.month.September": "شهریور",
  "7030.month.October": "مهر",
  "7030.month.November": "آبان",
  "7030.month.December": "آذر",
  "7030.bank.ansar": "انصار",
  "7030.bank.ayande": "آینده",
  "7030.bank.bpi": "پاسارگاد",
  "7030.bank.bsi": "صادرات",
  "7030.bank.edbi": "توسعه صادرات",
  "7030.bank.tose_tavon": "توسعه تعاون",
  "7030.bank.sina": "سینا",
  "7030.bank.shahr": "شهر",
  "7030.bank.day": "دی",
  "7030.bank.gardeshgari": "گردشگری",
  "7030.bank.hekmat": "حکمت ایرانیان",
  "7030.bank.iranZamin": "ایران زمین",
  "7030.bank.khavarmiyaneh": "خاورمیانه",
  "7030.bank.kowsar": "کوثر",
  "7030.bank.mehr": "مهر",
  "7030.bank.melal": "ملل",
  "7030.bank.resalat": "رسالت",
  "7030.bank.enovin": "اقتصاد نوین",
  "7030.bank.ghavamin": "قوامین",
  "7030.bank.karafarin": "کارآفرین",
  "7030.bank.keshavarzi": "کشاورزی",
  "7030.bank.maskan": "مسکن",
  "7030.bank.mebank": "مهر افتصاد",
  "7030.bank.mellat": "ملت",
  "7030.bank.melli": "ملی",
  "7030.bank.parsian": "پارسیان",
  "7030.bank.post": "پست بانک",
  "7030.bank.refah": "رفاه کارگران",
  "7030.bank.saman": "سامان",
  "7030.bank.bim": "صنعت و معدن",
  "7030.bank.sarmaye": "سرمایه",
  "7030.bank.sepah": "سپه",
  "7030.bank.tejarat": "تجارت",
  "7030.bank.unknown": "ناشناس",

  "7030.user.wellcome": "به سامانه هفتادسی خوش آمدید",
  "7030.user.enterPhoneNum": "لطفاًً شماره موبایل خود را وارد کنید",
  "7030.user.enterPhone": "لطفاً شماره تلفن خود را وارد کنید",
  "7030.user.phoneNumHolder": "0912xxxxx89 مثلاً",
  "7030.user.isInvite": "دعوت شده هستید؟",
  "7030.user.ppPerfix": " با ثبت ‌نام در هفتادسی ",
  "7030.user.ppSuffix": " را می‌پذیرم. ",
  "7030.user.pp": " قوانین و مقررات ",
  "7030.user.verifying": "اطلاعات شما در دست بررسی است",
  "7030.user.verified": "اطلاعات هویتی شما تایید شده است",
  "7030.user.rejected": "احراز هویت، مورد تایید قرار نگرفته است",
  "7030.user.unverified": "احراز هویت، مورد تایید قرار نگرفته است",
  "7030.user.missingDocumnets": "احراز هویت، به علت کمبود مدارک تایید نشده است",
  "7030.user.banned": "دسترسی شما به این سامانه مجاز نیست!",
  "7030.user.addAReferId": "باید یک شناسه دعوت وارد کنید!",
  "7030.transaction.title": "تراکنش‌ها",
  "7030.internetPackage.title": "بسته‌های اینترنت",
  "7030.internetPackage.detailes": "جزئیات بسته",
  "7030.charge.title": "شارژ و اینترنت تلفن همراه",
  "7030.charge.myNumber": "خودم",
  "7030.charge.direct": "شارژ مستقیم",
  "7030.charge.internet": "اینترنت",
  "7030.charge.my": "شارژهای من",
  "7030.charge.code": "کد شارژ",
  "7030.charge.package": "عنوان بسته",
  "7030.charge.internetPackage": "بسته اینترنت",
  "7030.charge.normal": "عادی",
  "7030.charge.ladies": "بانوان",
  "7030.charge.young": "جوانان",
  "7030.charge.amazing": "شگفت انگیز",
  "7030.charge.postpaidbill": "سیمکارت دائمی",
  "7030.charge.createFaveNum": "شماره جدید",
  "7030.charge.ForNumber": "برای شماره",
  "7030.charge.tarabordStatus": "وضعیت ترابرد",
  "7030.charge.chargePurchase": "خرید شارژ",
  "7030.charge.internetPurchase": "خرید بسته اینترنتی",
  "7030.charge.caNotDetectTheOperatorSelectAnotherOne": " اپراتور این شماره تشخیص داده نشد. لطفا اپراتور خود را انتخاب نمایید",
  "7030.charge.tarabordHelper": "راهنمای ترابرد",
  "7030.charge.addCredit": "افزایش اعتبار (مبلغ @param تومان کسری)",
  "7030.charge.fromFrequently": "از همیشگی‌ها",
  "7030.charge.delNumber": "حذف شماره",
  "7030.charge.doesNumber": "آیا شماره",
  "7030.common.deleteIt": "حذف شود",
  "7030.common.allIncomeUnillNow": "مجموع درآمد تاکنون:",
  "7030.common.allIncome": "مجموع درآمد",
  "7030.common.todayIncome": "درآمد امروز",
  "7030.common.allIncomeTillNow": "مجموع کل درآمد تاکنون",
  "7030.common.removableIncome": "درآمد قابل برداشت",
  "7030.common.wallet": "کیف پول",

  "7030.inquiry.recentDetailCar": "جزئیات خلافی خودرو",
  "7030.inquiry.recentDetailMotor": "جزئیات خلافی خودرو",
  "7030.inquiry.search": "استعلام",
  "7030.inquiry.searchWithCode": "پرداخت با شناسه",
  "7030.inquiry.bill": "استعلام قبض",
  "7030.inquiry.waterBill": "قبض آب",
  "7030.inquiry.electricityBill": " قبض برق",
  "7030.inquiry.gasBill": " قبض گاز",
  "7030.inquiry.gasSubscriptionCodeBill": " قبض گاز",
  "7030.inquiry.gasBillIdBill": " قبض گاز",
  "7030.inquiry.phoneBill": " قبض تلفن ",
  "7030.inquiry.mobileBill": "قبض موبایل",
  "7030.inquiry.list": "قبض",
  "7030.inquiry.billCode": "شناسه",
  "7030.inquiry.payment": "پرداخت با شناسه",
  "7030.inquiry.my": "قبض‌های من",
  "7030.inquiry.water": "آب",
  "7030.inquiry.electricity": "برق",
  "7030.inquiry.accountCode": "شماره اشتراک",
  "7030.inquiry.gas": "گاز",
  "7030.inquiry.gasSubscriptionCode": "گاز",
  "7030.inquiry.mobile": "تلفن همراه",
  "7030.inquiry.phone": "تلفن ثابت",
  "7030.inquiry.landline": "تلفن ثابت",
  "7030.inquiry.inquiry": "استعلام بدهی",
  "7030.inquiry.inquiryCar": "استعلام",
  "7030.inquiry.myCars": "خودروهای من",
  "7030.inquiry.listCar": "لیست خودرو",
  "7030.inquiry.technicalInspection": "معاینه فنی خودرو",
  "7030.inquiry.freewayTollBill": "عوارض آزادراهی",
  "7030.inquiry.freewayTollBillPage": "استعلام عوارض آزادراهی",
  "7030.inquiry.licenseStatus": "وضعیت گواهینامه",
  "7030.inquiry.licenseStatusPage": "استعلام وضعیت گواهینامه",
  "7030.inquiry.drivingAccident": "تصادفات رانندگی",
  "7030.inquiry.detailedTrafficFines": " خلافی خودرو",
  "7030.inquiry.withDetailed": "استعلام با جزئیات",
  "7030.inquiry.detailedTrafficFinesCheckBod": "با انتخاب استعلام با جزئیات ,لیست جرائم با جزئیات و تصاویر دوربین ها نمایش داده میشود",
  "7030.inquiry.detailedTrafficFinesResult": " خلافی خودرو با جزئیات",
  "7030.inquiry.detailedTrafficFinesPage": " استعلام خلافی خودرو",
  "7030.inquiry.aggregatedTrafficFines": "  خلافی خودرو بدون جزئیات",
  "7030.inquiry.aggregatedMotorTrafficFines": "  خلافی موتور بدون جزئیات",
  "7030.inquiry.detailedMotorTrafficFines": " خلافی موتور",
  "7030.inquiry.records": "سوابق استعلامات",
  "7030.inquiry.detailedMotorTrafficFinesResult": " خلافی موتور با جزئیات",
  "7030.inquiry.detailedTrafficFinesDetai": " جزئیات خلافی خودرو",
  "7030.inquiry.detailedMotorTrafficFinesDetail": " جزئیات خلافی موتور",
  "7030.inquiry.detailedMotorTrafficFinesPage": "  استعلام خلافی موتور",
  "7030.inquiry.withDetail": "  با جرئیات",
  "7030.inquiry.withoutDetail": "بدون جزئیات",
  "7030.inquiry.resultInquery": "نتایج استعلامات",
  "7030.inquiry.fineTotalAmount": "مبلغ کل خلافی",
  "7030.inquiry.TotalAmount": "مجموع پرداختی",
  "7030.inquiry.finePayAmount": "مبلغ قیمت پرداختی",
  "7030.inquiry.freewayTollBillDesc":
    "برای مشاهده عوارض آزادراهی خود شماره پلاک خود را وار کنید.",
  "7030.inquiry.detailedTrafficFinesDesc":
    "برای استعلام خلافی خودرو شماره پلاک و مشخصات زیر را پرکنید.",
  "7030.inquiry.detailedMotorTrafficFinesDesc":
    "برای استعلام خلافی موتور شماره پلاک و مشخصات زیر را پر کنید.",
  "7030.inquiry.licenseStatusDesc":
    "برای استعلام وضعیت گواهینامه خود , مشخصات زیر را پر کنید.",
  "7030.inquiry.negativeScoreDesc":
    "برای استعلام نمره منفی گواهینامه خود , مشخصات زیر را پر کنید..",
  "7030.inquiry.car": "خودرو",
  "7030.inquiry.carPersian": "ماشین",
  "7030.inquiry.freewayToll": "عوارض آزادراهی",
  "7030.inquiry.PayInquery": "استعلام",
  "7030.inquiry.motor": "موتور",
  "7030.inquiry.vinHolder": "شماره VIN خودرو را وارد کنید",
  "7030.inquiry.certificateHolder": "شماره گواهینامه ",
  "7030.inquiry.phoneNumber": "شماره تماس ",
  "7030.inquiry.phoneNumberdec": "برای مثال ۰۹۱۰۵۳۶۳۴۵۴ ",
  "7030.inquiry.nationalCode": "کد ملی ",
  "7030.inquiry.nationalCodDes": "شماره ده رقمی گواهینامه خود را وارد کنید ",
  "7030.inquiry.nationalCodedec": "کد ملی خود را وارد کنید",
  "7030.inquiry.vinNum": "VIN شماره‌ی",
  "7030.inquiry.certificateNum": "شماره گواهینامه را وارد نمایید",
  "7030.inquiry.status": "وضعیت",
  "7030.inquiry.expireDate": "تاریخ انقضا",
  "7030.inquiry.negativeScore": "نمره منفی",
  "7030.inquiry.negativeScorePage": " استعلام نمره منفی گواهینامه",
  "7030.inquiry.negativeScoreLicence": "نمره منفی گواهینامه",
  "7030.inquiry.licenseStatusResult": " گواهینامه",
  "7030.inquiry.offenseCount": "تعداد تخلف",
  "7030.inquiry.province": "استان",
  "7030.inquiry.location": "محل تصادف",
  "7030.inquiry.accidentType": "نوع تصادف",
  "7030.inquiry.accidentCulprit": "مقصر",
  "7030.inquiry.plateNum": "شماره پلاک",
  "7030.inquiry.carPlateNum": "شماره پلاک خودرو",
  "7030.inquiry.motorPlateNum": "شماره پلاک موتور",
  "7030.inquiry.station": "پلیس راه",
  "7030.inquiry.saveCarCardData": "ذخیره اطلاعات کارت وسیله نقلیه",
  "7030.inquiry.saveLicenceNumber": "ذخیره شماره گواهینامه رانندگی",
  "7030.inquiry.drivingLicense": "‌گواهینامه‌ها",
  "7030.inquiry.carName": "نام خودرو",
  "7030.inquiry.vehecle": "نام وسیله نقلیه",
  "7030.inquiry.MotorName": "نام موتور",
  "7030.inquiry.forEXPeugeot": "مثلاٌ پژو 206",
  "7030.inquiry.VINNumber": "شماره VIN",
  "7030.inquiry.enterYourVehicleCardData":
    "لطفاًً اطلاعات کارت وسیله نقلیه خود را وارد نمائید:",
  "7030.inquiry.enterYourVehiclePlateNumData":
    "لطفاًً اطلاعات پلاک وسیله نقلیه خود را وارد نمائید:",
  "7030.inquiry.enterOwnerAndLicenseNumber":
    "لطفاًً نام صاحب گواهینامه و شماره گواهینامه را وارد نمائید:",
  "7030.inquiry.carBarcode": "شماره بارکد پشت کارت خودرو",
  "7030.inquiry.edditBill": "ویرایش قبض",
  "7030.inquiry.enterCarBarcode": "شناسه 8 یا 9 رقمی پشت کارت وسیله نقلیه",
  "7030.inquiry.cardOwnerName": "نام صاحب کارت را وارد کنید",
  "7030.inquiry.enterCardOwnerName": "نام صاحب گواهینامه را وارد کنید",
  "7030.inquiry.enterDrivingLicenseNumber": "شماره گواهینامه را وارد کنید",
  "7030.inquiry.saveVehicleCard": "افزودن کارت وسیله نقلیه",
  "7030.inquiry.saveVehiclePlateNumber": "افزودن پلاک وسیله نقلیه",
  "7030.inquiry.addLicenseId": "افزودن شماره گواهینامه رانندگی",
  "7030.inquiry.saveDrivingLicense": "افزودن کارت گواهینامه",
  "7030.inquiry.ticketsDesc":
    "برای استعلام جریمه، شناسه 8 یا 9 رقمی پشت کارت وسیله نقلیه خود را وارد کنید.",
  "7030.inquiry.ticketBarCode": "شماره بارکد وسیله نقلیه",
  "7030.inquiry.municipality": "عوارض شهرداری",
  "7030.inquiry.tax": "مالیات",
  "7030.inquiry.ticket": "جریمه راهنمایی رانندگی",
  "7030.inquiry.unknown": "نامشخص",
  "7030.inquiry.tickets": "خلافی خودرو",
  "7030.inquiry.waterDesc":
    "تنها با وارد کردن @param خود، می‌توانید بدهی قبض را استعلام و سپس پرداخت کنید.",
  "7030.inquiry.billCodeHolder": "شناسه ی قبض خود را وارد کنید",
  "7030.inquiry.accountCodeHolder": "کد اشتراک خود را وارد کنید",
  "7030.inquiry.billIdHolder": "شناسه قبض خود را وارد کنید",
  "7030.inquiry.billPaymentHolder": "شناسه ی پرداخت خود را وارد کنید",
  "7030.inquiry.mobileHolder": "شماره موبایل خود را وارد کنید",
  "7030.inquiry.IdDesc": "شناسه قبض و شناسه پرداخت را وارد کنید.",
  "7030.inquiry.phoneHolder": "شماره تلفن خود را وارد کنید",
  "7030.inquiry.ticketHolder": "شماره پشت کارت خودروی خود را وارد کنید",
  "7030.inquiry.billId": "شناسه قبض",
  "7030.inquiry.paymentId": "شناسه پرداخت",
  "7030.inquiry.myBills": "قبض‌های من",
  "7030.inquiry.mobileTitle": "شماره موبایل",
  "7030.inquiry.phoneTitle": "شماره تلفن",
  "7030.inquiry.BillTitle": "قبوض خدماتی ",
  "7030.inquiry.phoneAndMobile": "تلفن و تلفن همراه",
  "7030.inquiry.chooseBillCategory": "دسته‌بندی قبض را انخاب کنید",
  "7030.inquiry.billType": "نوع قبض",
  "7030.inquiry.gasBillInquiry": "استعلام این قبض گاز",
  "7030.inquiry.electricityBillInquiry": "استعلام این قبض برق",
  "7030.inquiry.waterBillInquiry": "استعلام این قبض آب",
  "7030.inquiry.phoneBillInquiry": "استعلام این قبض تلفن",
  "7030.inquiry.mobileBillInquiry": "استعلام این قبض موبایل",

  "7030.inquiry.modalMessageMotor": "پرداخت خلافی موتور",
  "7030.inquiry.modalMessageCar": "پرداخت خلافی خودرو",
  "7030.inquiry.modalMessageContent": "کاربر عزیز دقت داشته باشید که اطلاعات خلافی شما بروز رسانی نشده است، تنها در صورتی پرداخت نمایید که از عدم پرداخت آن اطمینان دارید",
  "7030.inquiry.billIdHelper": "راهنمای شناسه قبض",
  "7030.bill.city": "شهر",
  "7030.bill.deliveryType": "نوع جریمه",
  "7030.bill.location": "محل",
  "7030.bill.date": "تاریخ",
  "7030.bill.desc": "توضیحات",
  "7030.bill.address": "آدرس",
  "7030.bill.ownerName": "صاحب امتیاز",
  "7030.bill.persianDate": "مهلت پرداخت",
  "7030.bill.previousDate": "تاریخ قرائت",
  "7030.bill.addBillTitle": "افزودن قبض جدید",
  "7030.bill.addBill": "افزودن قبض",
  "7030.bill.addCarTitle": "افزودن خودروی جدید",
  "7030.bill.addPhoneNumber": "افزودن شماره جدید",
  "7030.bill.selectCategory": "انتخاب دسته‌بندی",
  "7030.bill.selectBillType": "نوع قبض خود را انتخاب کنید",
  "7030.bill.dillId": "شناسه قبض",
  "7030.bill.billInputTitle": "عنوان",
  "7030.bill.ExHome": "مثلاً: خونه",
  "7030.bill.delBillId": "آیا از حذف قبض @param مطمئنید؟",
  /* materials */
  "7030.mobile": "شماره موبایل",
  "7030.mobile.ownerName": "نام دارنده شماره ",
  "7030.mobileDescription": "شماره موبایل خود را وارد کنید",
  "7030.tarabord": "ترابرد",
  "7030.chargeType": "نوع شارژ",
  "7030.chargeAmount": "مبلغ شارژ",
  "7030.chargeAmountDescription": "مبلغ دلخواه (تومان)",
  "7030.buy": "خرید",
  "7030.thousands": " هزار تومان",
  "7030.one": "1",
  "7030.two": "2",
  "7030.five": "5",
  "7030.ten": "10",
  "7030.twenty": "20",
  "7030.fifty": "50",
  "7030.oneTh": "100",
  "7030.normalCharge": "عادی",
  "7030.irancelSpec": "شگفت‌انگیز",
  "7030.postPaidSim": "سیم‌کارت دائمی",
  "7030.simType": "نوع سیم‌کارت",
  "7030.save": "ذخیره",
  "7030.data": "دیتا",
  "7030.prePaid": "اعتباری",
  "7030.postPaid": "دائمی",
  "7030.TD-LTE": "TD-LTE",
  "7030.pre-post": "همراه+ثابت..",
  "7030.searchInternetPack": "جستجو بسته‌ها",
  "7030.operator": "اپراتور",
  "7030.mci": "همراه اول",
  "7030.irancell": "ایرانسل",
  "7030.rightel": "رایتل",
  "7030.shatel": "شاتل",
  "7030.tci": "مخابرات",
  "7030.seeAll": "مشاهده همه",
  "7030.frequently": "همیشگی‌ها",
  "7030.recentlyPaid": "پرداخت‌های اخیر",
  "7030.hezar": "1000 تومانی",
  "7030.date": "10 شهریور 17:47",
  "7030.transaction.transactionType": "نوع تراکنش",
  "7030.transaction.desc": "شرح تراکنش",
  "7030.transaction.datetime": "زمان تراکنش",
  "7030.transaction.identifier": "کد تراکنش",
  "7030.transaction.price": "مبلغ تراکنش",
  "7030.transaction.priceWithTax": "مبلغ قابل پرداخت با احتساب مالیات",
  "7030.transaction.sourceCard": "کارت مبدا",
  "7030.transaction.receiverName": "نام دریافت کننده",
  "7030.transaction.destinationCard": "کارت مقصد",
  "7030.transaction.chargeType": "نوع شارژ",
  "7030.transaction.phoneNumber": "شماره",
  "7030.transaction.code": "شماره بارکد",
  "7030.transaction.billCode": "شناسه قبض",
  "7030.transaction.billPaymentCode": "شناسه پرداخت",
  "7030.transaction.airlineNum": "شماره پرواز",
  "7030.transaction.flyDatetime": "زمان پرواز",
  "7030.transaction.source": "مبدا پرواز",
  "7030.transaction.destination": "مقصد پرواز",
  "7030.transaction.airlineName": "هواپیمایی",
  "7030.transaction.passengerName": "مسافر",
  "7030.transaction.addFave": "افزودن به همیشگی",
  "7030.transaction.repeat": "تکرار تراکنش",
  "7030.transaction.orderTracking": "پیگیری سفارش",
  "7030.transaction.trackingCode": "کد پیگیری",
  "7030.transaction.share": "اشتراک‌گذاری",
  "7030.transaction.download": "دانلود رسید",
  "7030.transaction.inqueryResult": "مشاهده استعلام",
  "7030.transaction.downloadTicket": "دانلود بلیت",
  "7030.transaction.refundTicket": "استرداد بلیت",
  "7030.transaction.tanksForShopping": "باتشکر از خرید شما،",
  "7030.transaction.processingOrder": "سفارش شما در حال بررسی می باشد.",
  "7030.transaction.successOrder": "سفارش شما با موفقیت ثبت شد.",
  "7030.transaction.failedOrder": "متاسفانه خرید شما با موفقیت انجام نشد.",
  "7030.transaction.ifDeducted": "در صورت کسر مبلغ از حساب شما، درگاه بانکی آن را",
  "7030.transaction.returnsInHours": "کمتر از ۷۲ ساعت به حساب شما باز میگرداند.",

  "7030.income.title": "کسب درآمد",
  "7030.income.invite": "دعوت دوستان",
  "7030.income.myIds": "شناسه‌های من",
  "7030.income.withdrawl": "درخواست نقدی برداشت درآمد",
  "7030.income.changeToCredit": "تبدیل به اعتبار",
  "7030.income.withdrawlFrom7030": "برداشت از اعتبار 7030",
  "7030.income.dailyProfits": "درآمدهای روزانه",
  "7030.income.recentIncome": "درآمدهای اخیر",
  "7030.income.turnover": "گردش حساب",
  "7030.income.dailyProfit": "درآمد روزانه",
  "7030.income.payTo": "واریز به حساب",
  "7030.income.byMe": "توسط خودم",
  "7030.income.incomeHelper": "راهنمای کسب درآمد از سامانه هفتادسی",
  "7030.income.minCreditToExchange": "حداقل مبلغ تبدیل به اعتبار برای سطح کاربری شما،",
  "7030.income.incomes": "درآمدها",
  "7030.income.incomeTour": "تور کسب درآمد",
  "7030.income.inviteWithId": "دعوت سریع",
  "7030.income.preRegisterWithHaftadsi": "دعوت از طریق سامانه هفتادسی (دعوت خصوصی)",
  "7030.income.inviteWithPreRegister": "دعوت با پیش ثبت نام",
  "7030.income.enterYourFeriendsNumber": 'شماره دوستات رو وارد میکنی تا با هم دعوتشون کنیم',
  "7030.income.sentInvitations": "دعوت های ارسال شده",
  "7030.income.thisWeekInvitation": "دعوت شدگان این هفته",
  "7030.income.invitees": "دعوت شدگان",
  "7030.income.registeredIds": "شناسه‌های ثبت شده",
  "7030.income.registeredFeriends": "دوستان ثبت‌نام شده",
  "7030.income.sentInvitationsSecond": "دعوتنامه‌های ارسالی",
  "7030.income.noOneHasRegistered": "کسی از دوستان شما ثبت‌نام نکرده است",
  "7030.income.noInvitationsHaveSent": "هنوز دعوتنامه‌ای ارسال نکرده‌اید",
  "7030.income.inviteYourFeriendsWithId": "به صورت مستقیم با شناسه دعوت، دوستاتو دعوت میکنی.",
  "7030.income.allInvitedFeriends": "تعداد مدعوین کل شما",
  "7030.income.invitationWay": "راه های دعوت",
  "7030.income.sixIdDesc": 'لینک اختصاصی زیر، لینک ویژه شما در سوپر اپلیکیشن هفتادسی است تا کاربران با کد معرف شما وارد سامانه بشوند.',
  "7030.income.idChooseDesc": "شما می‌توانید این لینک را در بایو اینستاگرام، وبلاگ، بنرهای تبلیغاتی سایت‌تان، گروه‌های تلگرامی و ... استفاده کنید. کاربران مختلف با کلیک کردن بر روی لینک و ثبت‌نام در هفتادسی، به عنوان کاربران دعوت شده از سمت شما شمرده می‌شوند.",
  "7030.income.chooseYourReferIdAndEdit": "شناسه دعوت خود را انتخاب کنید , و در صورت لزوم  متن را ویرایش کنید.",
  "7030.income.sendInvitationToContacts": "ارسال دعوتنامه به مخاطبین",
  "7030.income.invitationTextHasCopiedShareIt": "متن دعوتنامه با موفقیت کپی شد! آن را با مخاطبین خود به اشتراک بگذارید",
  "7030.income.confirmNumbers": "تایید و بررسی شماره‌ها",
  "7030.income.confirmNumber": "تایید و بررسی شماره‌ها",
  "7030.income.referIds": "شناسه‌ها",
  "7030.income.referId": "شناسه",
  "7030.incoming.invite": "دعوت",
  "7030.incoming.myIncome": "درآمد من",
  "7030.incoming.learnIncome": "آموزش",
  "7030.incoming.myInvite": "مدعوین من",
  "7030.incoming.invitessLen": "تعداد مدعوین",
  "7030.incoming.invitessAll": "تعداد کل مدعوین: ",
  "7030.incoming.invitessWeekly": "مدعوین جدید (یک هفته): ",
  "7030.incoming.friendInvite": "دعوت دوستان",
  "7030.incoming.invitessCount": "تعداد دوستان دعوت شده: ",
  "7030.incoming.invitessFeriends": "دوستان دعوت شده: ",
  "7030.incoming.sentInvitations": "دعوتنامه‌های ارسال شده:",
  "7030.incoming.registerCount": "تعداد دوستان ثبت نام شده: ",
  "7030.incoming.deleteCount": "مدعوین شناسه های حذف شده: ",
  "7030.incoming.person": "نفر",
  "7030.incoming.latestInvitess": "آخرین مدعوین",
  "7030.incoming.referIDsCount": "تعداد شناسه‌ها",
  "7030.incoming.myReferIDs": "شناسه‌های من",
  "7030.incoming.referIDs": "شناسه‌های دعوت",
  "7030.incoming.createReferCode": "ساخت شناسه جدید",
  "7030.incoming.createInviteCodeDesc":
    "شناسه مورد نظر خود را بنویسید.",
  "7030.incoming.saveInviteCode": "بررسی و ساخت شناسه",
  "7030.incoming.lawInviteCode": "قوانین ساخت شناسه",
  "7030.incoming.minChar": "حداقل ۵ کاراکتر",
  "7030.incoming.combineAlpahAndNum": "	فقط حروف و اعداد انگلیسی استفاده شود. (کوچک یا بزرگ بودن حروف اهمیت ندارد.)",
  "7030.incoming.underline": "	برای فاصله از علامت «زیر خط» (_) استفاده کنید.",
  "7030.incoming.avalible": "	توسط دیگر کاربران نباید انتخاب شده باشد.",
  "7030.incoming.invitation": "دعوتنامه",
  "7030.incoming.invitationDesc":
    "شناسه دعوت خود را انتخاب کنید و پس از نوشتن متن دعوت، روی ادامه کلیک کنید.",
  "7030.incoming.selectInvitation": "انتخاب شناسه",
  "7030.incoming.bodyTextInvitation": "متن دعوتنامه",
  "7030.incoming.bodyTextInvitationHolder": "متن دعوتنامه خود را بنویسید",
  "7030.incoming.sendSMSInvitation": "ارسال پیامک دعوت به مخاطبین",
  "7030.incoming.delRefer": "حذف شناسه",
  "7030.incoming.delReferID": "آیا از حذف شناسه @param مطمئنید؟",
  "7030.incoming.delReferIDDesc":
    "با حذف شناسه، مدعوین آن به شماره تلفن همراه شما منتقل میشود و در صورتیکه توسط کاربر دیگری رزرو شود، نمیتوانید دوباره ثبت کنید",
  "7030.incoming.myInvitees": "مدعوین من",
  "7030.incomming.selectIban": "انتخاب شماره شبا",
  "7030.incomming.withdrawlAmount": "مبلغ درخواستی جهت برداشت",
  "7030.incomming.convertAmount": "مبلغ تبدیل به اعتبار",
  "7030.incomming.convertToCredit": " تبدیل به اعتبار",
  "7030.incomming.enterWithdrawl": "مبلغ درخواستی را وارد کنید",
  "7030.incomming.amountForWithdrawl": "مبلغ قابل برداشت",
  "7030.incomming.withdrawTitle": "برداشت درآمد",
  "7030.incomming.sendInvitation": "ارسال دعوتنامه",
  "7030.incomming.makeReferId": "ساخت شناسه دعوت",
  "7030.incomming.IdEx": "مثال:ir_7030",
  "7030.incomming.referId": "شناسه دعوت",
  "7030.incomming.income": "درآمد",
  "7030.incomming.invited": "مدعوین",
  "7030.incoming.id": "شناسه:",
  "7030.incomming.canWithId": "می‌توانید با شناسه معرف",
  "7030.incomming.invitePeople":
    "دیگران را دعوت کنید تا به زیرمجموعه شما بپوندند.",
  "7030.incomming.oneWeek": "یک هفته",
  "7030.incomming.oneMonth": "یک ماه",
  "7030.incomming.threeMonth": "3 ماه",
  "7030.incomming.sixWeek": "6 ماه",
  "7030.incomming.descInvite":
    "سلام خوبی؟ من یه سوپر اپلیکیشن پیدا کردم که با هر خرید، ۳۰٪ از سود خریدت رو برمی‌گردونه! از خرید شارژ، اینترنت و قبض تا بلیت هواپیما، بیمه و فروشگاه تمام کالاها رو هم رایگان ارسال می‌کنه! \n با این لینک ثبت‌نام کن:\n",
  "7030.incoming.share": "ارسال لینک دعوت",
  "7030.incoming.shareDesc": "اشتراک‌گذاری در شبکه‌های اجتماعی",
  "7030.incoming.friendInviteDesc": "دعوت مستقیم از طریق شماره تلفن",
  "7030.incoming.checkNum": "بررسی شماره‌ها",
  "7030.incoming.minPriceWithdrawlDesc":
    "متاسفانه مبلغ قابل برداشت شما کافی نیست. برای برداشت درآمد، حداقل باید ۱۰ هزار تومان درآمد داشته باشید.",
  "7030.incoming.maxPriceWithdrawlDesc": "عالی! درآمد شما برای برداشت کافی‌ست و مبلغ درخواستی شما باید بیش از ۱۰ هزار تومان باشد.",
  "7030.incoming.addIban": "شماره شبای جدید",
  "7030.incoming.invitationList": "لیست ارسال دعوتنامه",
  "7030.incoming.registerPendding": "در انتظار تکمیل فرآیند ثبت نام",
  "7030.incoming.registered": "ثبت نام شده",
  "7030.incoming.noInvites": "هنوز کسی به زیر مجموعه ی شما اضافه نشده است.",
  "7030.incoming.noInvitesDesc":
    "از دیگران بخواهید با کد معرف شما در هفتادسی ثبت نام کنند تا زیرمجموعه ی شما قرار بگیرند.",
  "7030.incoming.sendingInvitation": "ارسال دعوتنامه",
  "7030.profile.acountPass": "رمز حساب کاربری",
  "7030.profile.identity": "احراز هویت",
  "7030.profile.editProfile": "ویرایش پروفایل",
  "7030.profile.changePass": "تغییر رمزعبور",
  "7030.profile.createPass": "ایجاد رمز عبور",
  "7030.profile.referID": "شناسه دعوت معرف",
  "7030.profile.aboutUs": "درباره ما",
  "7030.profile.privacy": "قوانین مقررات",
  "7030.profile.faq": "سوالات متداول",
  "7030.profile.contactUs": "تماس با ما",
  "7030.profile.singout": "خروج از حساب",
  "7030.profile.startuoIdentity": "شروع احراز هویت",
  "7030.profile.firstname": "نام",
  "7030.profile.lastname": "نام خانوادگی",
  "7030.profile.firstnameEn": "نام لاتین",
  "7030.profile.lastnameEn": "نام خانوادگی لاتین",
  "7030.profile.personalCode": "کد ملی",
  "7030.profile.personalCodeHolder": "03701234567",
  "7030.profile.mail": "ایمیل",
  "7030.profile.mailHolder": "info@7030.ir",
  "7030.profile.mobile": "تلفن همراه",
  "7030.profile.mobileHolder": "0912123456",
  "7030.profile.iban": "شماره شبا",
  "7030.profile.ibanHolder": "123456789745612358",
  "7030.profile.okAndContinue": "تایید و ادامه",
  "7030.profile.editInfo": "ویرایش اطلاعات",
  "7030.profile.connectToSupport": "ارتباط با پشتیبانی",
  "7030.profile.yourReferId": "شناسه دعوت معرف شما",
  "7030.profile.enterYourReferId": "شناسه معرف خود را وارد کنید",
  "7030.profile.submitReferId": "ثبت شناسه دعوت",
  "7030.profile.referIdTitle": "شناسه دعوت معرف",
  "7030.profile.notEqualNewPass":
    "تکرار رمزعبور جدید با رمزعبور جدید برابر نیست",
  "7030.profile.oldPass": "رمزعبور فعلی",
  "7030.profile.newPass": "رمزعبور جدید",
  "7030.profile.repeatPass": "تکرار رمزعبور جدید",
  "7030.profile.enterAnewPass": "یک رمز جدید برای خود تعیین کنید",
  "7030.profile.repeatNewPass": "برای اطمینان رمز جدید را یکبار دیگر وارد کنید",
  "7030.profile.incorrectOTP": "کد فعالسازی درست وارد نشده است",
  "7030.profile.sendCodeInfo": "یک کد 5 رقمی به شماره @param فرستاده شد.",
  "7030.profile.incorrectRptAndpass": "رمز عبور و تکرار آن یکسان نیستند!",
  "7030.profile.acceptTerms": "سامانه هفتادسی موافق هستم",
  "7030.profile.with": "با",
  "7030.profile.uploadDocs": "بارگذاری تصویر مدارک",
  "7030.profile.editUploadedDocs": "ویرایش تصویر مدارک",
  "7030.profile.confirmMobile": "تایید شماره موبایل",
  "7030.profile.shouldBeYourMobilePhone":
    "*شماره موبایل حتماً باید متعلق به خودتان باشد.",
  "7030.profile.shouldBeYourId": "*شماره ملی حتماً باید متعلق به خودتان باشد.",
  "7030.profile.shouldBeYourIban":
    "*شماره شبا حتماً باید متعلق به خودتان باشد.",
  "7030.profile.toCompeletIDV": "جهت تکمیل مراحل احراز هویت، لطفاً ابتدا",
  "7030.profile.howToTakePhoto": "آموزش روش صحیح عکاسی",
  "7030.profile.readAndClickUpload":
    "را مطالعه کرده و سپس روی گزینه بارگذاری کلیک نمایید.",
  "7030.profile.doIDVandearnMoney": "با انجام فرآیند احراز هویت، کسب درآمد کنید.",
  "7030.profile.clickForMreInfo": "چرا باید احراز هویت کنیم؟",
  "7030.profile.reviewInfo":
    "لطفاًً اطلاعات خود را جهت تایید نهایی بازبینی کنید:",
  "7030.profile.FnameAndLname": " نام و نام خانوادگی:",
  "7030.profile.Nnumber": "شماره ملی:",
  "7030.profile.banckName": "نام بانک:",
  "7030.profile.mobileNumber": "شماره موبایل:",
  "7030.profile.ibanNumber": "شماره شبا:",
  "7030.profile.uploadedImage": "تصویر بارگذاری شده:",
  "7030.profile.acceptRules": "با قوانین و مقررات سامانه هفتادسی موافق هستم.",
  "7030.profile.sentCode": "کدتایید ارسال شده به شماره",
  "7030.profile.enterIt": "را وارد نمایید.",
  "7030.profile.acountCredit": "اعتبار حساب",
  "7030.profile.currentCredit": "اعتبار موجود:",
  "7030.profile.askYourQuestion":
    "سوال‌های خود را با کارشناسان ما درمیان بگذارید.",
  "7030.profile.callSupport": "تماس با پشتیبانی",
  "7030.profile.level": "سطح:",
  "7030.profile.checkYourEnteredEmail": "لطفاً آدرس ایمیل وارد شده را بررسی کنید",
  "7030.profile.registerSetting": "ثبت تنظیمات",
  "7030.profile.areYouSureToSubmitSettings": "آیا از ثبت تغییراتی که در بخش تنظیمات کسب درآمد اعمال کردید مطمئن هستید؟",
  "7030.profile.canNotEditForOneMonth": "پس از این تا یک ماه قادر به ویرایش تنظیمات کسب درآمد نخواهید بود!",
  "7030.profile.areYouSureToResetIncomeSettings": "آیا از بازنشانی تنظیمات کسب درآمد مطمئن هستید؟",
  "7030.profile.myOrder": "خرید های من",
  "7030.profile.finance": "مالی",
  "7030.profile.favorit": "علاقه مندی ها",
  "7030.profile.myOponiopn": "دیدگاه های من",
  "7030.profile.setComment": "در انتظار ثبت نظر",
  "7030.profile.orderCardBtn": "ثبت نظر و امتیاز",
  "7030.profile.commentTitle": "ثبت دیدگاه و امتیاز",
  "7030.comment.title": "عنوان",
  "7030.comment.titleDesc": "عنوان نظر خود را بنویسید",
  "7030.comment.text": "نظر",
  "7030.comment.textDesc": "متن نظر خود را بنویسید",
  "7030.comment.suggestTitle": "آیا این محصول را به دیگران پیشنهاد  میدهید؟",
  "7030.comment.suggest": "پیشنهاد میکنم",
  "7030.comment.notSuggest": "مطمئن نیستم",
  "7030.comment.notSure": "پیشنهاد نمیکنم",
  "7030.comment.rating": "به این محصول چه امتیازی میدهید؟",
  "7030.comment.setComment": "ثبت دیدگاه",
  "7030.comment.acceptCm": "تایید شده",
  "7030.comment.penddingCm": "در انتظار تایید",
  "7030.comment.rejectCm": "تایید نشده",
  "7030.comment.notSuggestProd": "این محصول را پیشنهاد نمیکنم",
  "7030.comment.SuggestProd": "این محصول را پیشنهاد میکنم",
  "7030.comment.notSureProd": "مطمئن نیستم",
  "7030.comment.deleteCmTitle": "آیا از حذف نظر مطمئن هستید",
  "7030.text.referId":
    "اگر بدون شناسه دعوت ثبت‌نام کرده‌اید و اکنون قصد دارید با دوست خود کسب درآمد کنید، لازم است ابتدا شناسه دعوت خود را ثبت کنید.",
  "7030.text.referIdNote":
    "* توجه! این شناسه دعوت فقط یکبار قابل ثبت می‌باشد و قابل ویرایش نیست.",
  "7030.text.haveReferId":
    "درحال حاضر مدعو شما شناسه زیر می‌باشد، با استفاده از خدمات هفتادسی هم به خود و هم به معرف خود سود می‌رسانید.",
  "7030.text.transaction": "هنوز تراکنشی انجام نداده‌اید!",
  "7030.text.comment": "محصولی برای مشاهده موجود نیست!",
  "7030.text.wallet": "تراکنشی یافت نشد!",
  "7030.text.addCredit": "*حداقل مبلغ افزایش اعتبار هزار تومان می‌باشد.",
  "7030.text.withdrawl": "*حداقل مبلغ قابل برداشت ده هزار تومان می‌باشد.",
  "7030.messages.title": "پیام‌ها",
  "7030.messages.7030Desc": "پیام‌های اختصاصی از هفتادسی‌",
  "7030.charity.institutions": "مراکز",
  "7030.charity.institution": "مرکز",
  "7030.charity.constantPay": "پرداخت مستمر",
  "7030.charity.constantPays": "پرداخت‌های مستمر",
  "7030.charity.my": "نیکوکاری‌های من",
  "7030.charity.yourCoPayment": "نیکوکاریت مستمر شد!",
  "7030.charity.yourCoPaymentText":
    "از این پس به راحتی برای کارهای خیر خودت برنامه‌ریزی کنید.",
  "7030.charity.500": "500",
  "7030.charity.1000": "1",
  "7030.charity.2000": "2",
  "7030.charity.5000": "5",
  "7030.charity.10000": "10",
  "7030.charity.20000": "20",
  "7030.charity.recurrentPayment":
    "همچنین می‌توانید به @param به صورت مستمر پرداخت کنید.",
  "7030.charity.selectInstitution": "انتخاب مرکز",
  "7030.charity.periodicPay": "دوره پرداخت",
  "7030.charity.period": "دوره",
  "7030.charity.daily": "روزانه",
  "7030.charity.weekly": "هفتگی",
  "7030.charity.monthly": "ماهانه",
  "7030.charity.1": "روزانه",
  "7030.charity.7": "هفتگی",
  "7030.charity.30": "ماهانه",
  "7030.charity.day": "روز",
  "7030.charity.week": "هفته",
  "7030.charity.month": "ماه",
  "7030.charity.disable": "غیرفعال کردن",
  "7030.charity.edit": "ویرایش",
  "7030.charity.enablePayment": "فعال‌سازی پرداخت مستمر",
  "7030.charity.fajr": " صبح ",
  "7030.charity.payInOrg": " از اعتبار شما به حساب خیریه واریز خواهد شد.",
  "7030.charity.currentCredit": "اعتبار فعلی برای ",
  "7030.charity.priceOk": " کافی است.",
  "7030.charity.currentNoCredit": "اعتبار فعلی شما ناکافی است.",
  "7030.charity.sendNotifEmptyCredit": "آگاه‌سازی هنگام اتمام اعتبار",
  "7030.charity.sendNotifPayment": "آگاه‌سازی پس از هر پرداخت",
  "7030.charity.readMore": "بیشتر بخوانید...",
  "7030.charity.readLess": "کمتر...",
  "7030.charity.myCharity": "نیکوکاری من",
  "7030.charity.doCharity": "کار نیکو کردن از پر کردن است!",
  "7030.charity.coPaymentsDesc":
    "با اضافه کردن پرداخت مستمر می‌توانید با برنامه‌ریزی به نیکوکاری بپردازید.",
  "7030.charity.donateProfitFromShopping": " اهدای سود حاصل از خرید و",
  "7030.charity.profitFromShopping": "سود حاصل از خرید",
  "7030.charity.earnedIncome": "درآمد کسب شده",
  "7030.charity.profitFromYourShopping": "سود حاصل از خرید شما",
  "7030.charity.dailyWeeklyPayment": "پرداخت روزانه، هفتگی و...",
  "7030.charity.start": "شروع کنید",
  "7030.charity.charityProduct": "محصولات خیریه",
  "7030.charity.immediateSupport": "حمایت فوری و اهدای مستقیم پول به این مرکز",
  "7030.charity.repetitiveAmounts": "مبالغ پر تکرار",
  "7030.charity.donateToCharity": "اهدا به خیریه",
  "7030.charity.specialDonations": "اهداهای ویژه",
  "7030.charity.specialDonation": "اهدای ویژه",
  "7030.charity.toCharityTillNow": "به خیریه تا کنون",
  "7030.charity.continuesPaymentDsc": " پول خود را به صورت مستمر برای حمایت سازمان‌های خیریه ایران اهدا کنید مبلغ خود را وارد کنید",
  "7030.charity.enterYourAmount": "مبلغ خود را وارد کنید",
  "7030.charity.continuesPaymentDuration": "دوره پرداخت مستمر خود را انتخاب کنید",
  "7030.charity.payFromYpurCreditToCharity": "از اعتبار شما به حساب خیریه واریز خواهد شد",
  "7030.charity.creditIsNotEnough": "اعتبار شما کافی نیست",
  "7030.charity.active": "فعالسازی",
  "7030.charity.deactive": "غیرفعالسازی",
  "7030.charity.areYouSureToDeactiveContinuesPayment": "آیا از غیرفعالسازی پرداخت مستمر به",
  "7030.charity.areYouSure": " مطمئن هستید؟",
  "7030.charity.continuesPaymentEddited": "پرداخت مستمر با موفقیت ویرایش شد'",
  "7030.charity.specialDonationDsc": "هر لحظه میتوانید به خیریه‌ها و سازمان‌های مردم نهاد پول اهدا کنید و خیریه‌ها را در پیش برد این راه کمک کنید، شما میتوانید با پرداخت مستمر و سود حاصل از خرید و درآمد کسب شده به بنیادها و سازمان‌های خیریه در این راه خیر کمک کنید.",
  "7030.charity.continuesPaymentForCharity": "پرداخت مستمر برای خیریه",
  "7030.charity.continuesPaymentToCharity": "پرداخت مستمر به خیریه",
  "7030.charity.donated": "اهدا شده است.",
  "7030.charity.alreadyToCharity": "شما قبلاٌ به خیریه",
  "7030.charity.donate": "؟اهدا کنید",
  "7030.charity.doYouWant": "آیا میخواهید به",
  "7030.charity.dontHaveSpecialDonation": "شما در حال حاضر اهدای ویژه‌ای ندارید",
  "7030.charity.donateFromYourCredit": "از اعتبار شما اهدا می‌شود",
  "7030.charity.inTheFormOfContinuesPayment": "به صورت پرداخت مستمر",
  "7030.charity.hasDonated": "اهدا",
  "7030.charity.yourEarnedIncome": "درآمد کسب شده‌ی شما",
  "7030.charity.toThisCharity": "به این خیریه شده است.",
  "7030.charity.YourPurchaseProfit": "سود حاصل از خرید شما",
  "7030.shop.shoppingCenters": "مراکز فروش",
  "7030.shop.category": "دسته بندی",
  "7030.shop.shop": "فروشگاه",
  "7030.shop.submitCommentAndRate": "ثبت نظر و امتیاز",
  "7030.shop.shops": "فروشگاه‌ها",
  "7030.shop.newProduct": "جدیدترین محصولات",
  "7030.shop.product": "محصول",
  "7030.shop.products": "محصولات",
  "7030.shop.color": "رنگ",
  "7030.shop.moreInfo": "مشخصات",
  "7030.shop.finalBuy": "تکمیل خرید",
  "7030.shop.discountCode": "کد تخفیف",
  "7030.shop.sendInCity": "ارسال با پیک (مخصوص تهران)",
  "7030.shop.sendPost": "پست پیشتاز",
  "7030.shop.sendDelivery": "ارسال پیک",
  "7030.shop.forTehran": "(مخصوص تهران/تا 3 روز کاری)",
  "7030.shop.discountCodeHolder": "کد تخفیف را وارد کنید",
  "7030.shop.selectPostType": "لطفاً یکی از روش‌های زیر را انتخاب نمایید:",
  "7030.shop.setInfo": "لطفاً اطلاعات خود را تکمیل کنید:",
  "7030.shop.discountCodeMistake": "کد تخفیف وارد شده معتبر نیست.",
  "7030.shop.notSelectedColor": "رنگ محصول را انتخاب کنید.",
  "7030.shop.emptyField": "اطلاعات خود را وارد کنید.",
  "7030.shop.prePaymentProduct": "پیش فاکتور مرکز خرید ",
  "7030.shop.shoppingCenter": "مرکز خرید",
  "7030.shop.countProduct": "تعداد",
  "7030.shop.shippingCost": "هزینه حمل و نقل",
  "7030.shop.typeOfPost": "شیوه ارسال محصول",
  "7030.shop.postInfo": "اطلاعات ارسال",
  "7030.shop.myOrder": "خریدهای من",
  "7030.shop.detail": "جزئیات",
  "7030.shop.postPrice": "هزینه ارسال",
  "7030.shop.letsShopping": "خرید کنید",
  "7030.shop.emptyStateTitle": "هنوز کالایی خریداری نکرده‌اید!",
  "7030.shop.emptyStateText": "وضعیت خریدهای خود را در اینجا مشاهده می‌کنید.",
  "7030.shop.moreDetail": "جزئیات بیشتر",
  "7030.shop.lessDetail": "جزئیات کمتر",
  "7030.shop.allPayment": "پرداخت کل",
  "7030.shop.favorite": "علاقه‌مندی‌ها",
  "7030.shop.inHaftadsiShop": "در مرکز خرید هفتادسی",
  "7030.shop.productCount": "تعداد کالا",
  "7030.shop.kala": "کالا",
  "7030.shop.gotToShop": "برو به فروشگاه",
  "7030.shop.deleteShopPackage": "حذف بسته فروشگاه",
  "7030.shop.shopPackage": " بسته فروشگاه",
  "7030.shop.discountCodeCopied": "'کد تخفیف با موفقیت کپی شد!",
  "7030.shop.continueShopping": "ادامه خرید",
  "7030.shop.maximum": "حداکثر",
  "7030.shop.productCost": "مبلغ کالا",
  "7030.shop.productCostWithDiscount": "مبلغ کالا با تخفیف",
  "7030.shop.shoppingCart": "سبد خرید",
  "ا7030.shop.addTo": "افزودن به",
  "7030.shop.favorites": "علاقه مندی ها",
  "7030.common.haftadsiApp": "اپلیکیشن 7030",
  "7030.shop.addAddress": "آدرس جدید",
  "7030.shop.shopInfoCopied": "اطلاعات فروشگاه با موفقیت کپی شد!",
  "7030.shop.yourProfitFromthisPurchase": "سود شما از خرید این محصول:",
  "7030.shop.yourProfitFromyourInvitees": "سود حاصل از خرید مدعوین شما:",
  "7030.shop.productInfo": "مشخصات محصول",
  "7030.shop.compeletProductInfo": "لطفا اطلاعات مربوط به این محصول را تکمیل کنید",
  "7030.shop.orderDetail": "جزئیات سفارش",
  "7030.shop.addressAddedSuccessfully": "آدرس با موفقیت اضافه شد!",
  "7030.shop.addressDeletedSuccessfully": "آدرس با موفقیت حذف شد!",
  "7030.shop.addressDetail": "جزئیات آدرس",
  "7030.shop.addressTitle": "عنوان آدرس",
  "7030.shop.address": "آدرس",
  "7030.shop.selectProvinceFirst": "ابتدا استان مورد نظر خود را انتخاب کنید.",
  "7030.shop.containesAddressAndUnitNumber": "شامل آدرس محل پستی، پلاک، واحد",
  "7030.shop.postId": "کدپستی",
  "7030.shop.editAddress": "ویرایش آدرس",
  "7030.shop.registerAddress": "ثبت آدرس",
  "7030.shop.deleteAddress": "حذف آدرس",
  "7030.shop.allCelebrities": "همه سلبریتی‌ها",
  "7030.shop.doesNotExist": "وجود ندارد",
  "7030.shop.contactUsIfYouAreSeller": "اگر فروشنده هستید با ما تماس بگیرید",
  "7030.shop.noProductsWereFound": "محصولی یافت نشد",
  "7030.shop.delAddress": "آیا از حذف آدرس @param مطمئن هستید؟",
  "7030.shop.delShoppingCart": "آیا از حذف سبد خرید @param مطمئن هستید؟",
  "7030.shop.yourShoppingCartIsEmpty": "سبد خرید شما خالی است",
  "7030.shop.shoppingFromHaftadsi": "خرید از مرکز خرید هفتادسی",
  "7030.shop.deletFromShoppingCart": "حذف از سبد خرید",
  "7030.shop.activeOrderi": "فعالی",
  "7030.shop.proccessingOrderi": "در حال پردازشی",
  "7030.shop.sendingOrderi": "در حال ارسالی",
  "7030.shop.deliveredOrderi": "تحویل شده‌ای",
  "7030.shop.cancelledOrderi": "لغو شده‌ای",
  "7030.shop.postInfoSec": "مشخصات ارسال",
  "7030.shop.receiver": "تحویل گیرنده",
  "7030.shop.mobilePhone": "تلفن همراه",
  "7030.shop.destinationAddress": "آدرس ارسال",
  "7030.shop.orderInfo": "مشخصات سفارش",
  "7030.shop.orderNumber": "شماره سفارش",
  "7030.shop.orderDate": "تاریخ سفارش",
  "7030.shop.shipmentTrackingCode": "کدرهگیری مرسوله",
  "7030.shop.ProductPostCost": "هزینه ارسال کالا",
  "7030.shop.transactionHistory": "تاریخچه تراکنش",
  "7030.shop.successPayment": "پرداخت موفق",
  "7030.shop.unSuccessPayment": "پرداخت ناموفق",
  "7030.shop.gateWay": "درگاه",
  "7030.shop.bankReferenceNumber": "شماره مرجع بانک",
  "7030.shop.paymentTime": "زمان پرداخت",
  "7030.shop.trckingNumber": "شماره پیگیری",
  "7030.shop.payments": "مبلغ پرداختی",
  "7030.shop.paymentDetail": "جزئیات پرداخت",
  "7030.shop.costOfPost": "هزینه ارسال بسته",
  "7030.shop.packageDiscount": "تخفیفات بسته محصولات",
  "7030.shop.totalePriceOfPackage": "مجموع قیمت بسته محصولات",
  "7030.shop.totalPayment": "جمع کل پرداختی بسته‌ها",
  "7030.shop.totalPaymentOfAllPackages": "مجموع پرداخت کل بسته‌ها",
  "7030.shop.totalPackage": "جمع کل بسته‌ها",
  "7030.shop.paymentWay": "روش پرداخت",
  "7030.shop.costOfProducts": "قیمت کالاها",
  "7030.shop.free": "رایگان",
  "7030.shop.productsDiscount": "تخفیف کالاها",
  "7030.shop.payable": "قابل پرداخت",
  "7030.shop.backToCredit": "بازگشت اعتبار شما از این خرید",
  "7030.shop.compeletpurdchaseAndpayOff": "تکمیل خرید و پرداخت",
  "7030.shop.productPurchase": "خرید محصول",
  "7030.shop.fromHaftadsiShoppingCenter": "از فروشگاه هفتادسی",
  "7030.shop.ProductInfoCopied": "اطلاعات محصول با موفقیت کپی شد",
  "7030.shop.yourIncomeFromMarketing": "درآمد شما از بازاریابی این محصول",
  "7030.shop.productDescription": "توضیحات محصول",
  "7030.shop.relatedProducts": "محصولات مشابه",
  "7030.shop.addTo": "افزودن به",
  "7030.shop.searchIn": "جستجو در",
  "7030.shop.search": "جستجو",
  "7030.shop.yourSearchSearch": "تاریخچه جستجوهای شما",
  "7030.shop.relatedShops": "فروشگاه‌های مرتبط",
  "7030.shop.postalAddress": "آدرس ارسالی",
  "7030.shop.FirstNameAndLastNameOfReceiver": "نام و نام خانوادگی گیرنده",
  "7030.shop.enterDiscountCode": "کد تخفیف را وارد کنید",
  "7030.shop.registerTheCode": "ثبت کد",
  "7030.shop.postMethdOfProduct": "شیوه ارسال کالا",
  "7030.shop.noProductFound": "محصولی پیدا نشد",

  "7030.shop.totlaCostOfProducts": "مجموع مبلغ کالا",
  "7030.shop.totalProductsDiscount": "مجموع تخفیف کالاها",
  "7030.shop.totalProductsCostWithDiscount": "مجموع مبلغ کالا با تخفیف ",
  "7030.shop.userComments": "نظرات کاربران",
  "7030.shop.submitComments": "ثبت نظر",
  "7030.shop.noCommentsForthis": "نظری برای این محصول ثبت نشده است",
  "7030.shop.nothingFound": "موردی پیدا نشد!",

  "7030.myInfo.myAddress": "آدرس‌های من",
  "7030.myInfo.myBills": "قبض‌های من",
  "7030.myInfo.myCar": "خودروهای من",
  "7030.myInfo.myNumbers": "شماره‌های من",
  "7030.myInfo.myPassenger": "مسافرهای من",
  "7030.myInfo.theAddress": "آدرسی",
  "7030.myInfo.theBill": "قبضی",
  "7030.myInfo.theCar": "خودرویی",
  "7030.myInfo.theNumber": "شماره ای",
  "7030.myInfo.thePassenger": "مسافری",
  "7030.myInfo.licenseNumber": "شماره گواهینامه",
  "7030.myInfo.drivingLicense": "گواهینامه",
  "7030.myInfo.negativeScore": "نمره منفی گواهینامه",
  "7030.myInfo.fineInsurance": "استعلام خلافی",
  "7030.myInfo.vehicleCard": "کارت وسیله نقلیه",
  "7030.myInfo.passengerInfo": "اطلاعات مسافر",
  "7030.myInfo.numbers": "شماره ها",
  "7030.myInfo.cars": "خودروها",
  "7030.myInfo.bills": "قبض ها",
  "7030.myInfo.addresses": "آدرس ها",
  "7030.myInfo.passengers": "مسافرها",
  "7030.myInfo.myInfoWallet": "کیف اطلاعات من",
  "7030.myInfo.billInfo": "اطلاعات قبض",
  "7030.myInfo.haftadsiWebApp": "وب اپلیکیشن هفتادسی",
  "7030.myInfo.easyPayForBills": "پرداخت آسان قبض‌های شما با یک کلیک و بازگشت سود پرداخت به کیف پول شما",
  "7030.myInfo.callInfo": "اطلاعات تماس",
  "7030.myInfo.easyPurchaseforChargeAndNet": "خرید آسان انواع شارژ و بسته‌های اینترنت فقط با یک کلیک و بازگشت سود پرداخت به کیف پول شما",
  "7030.myInfo.carInfo": "اطلاعات خودرو",
  "7030.myInfo.easyInquiry": "استعلام آسان معاینه فنی خودرو و نمره منفی گواهینامه فقط با یک کلیک",
  "7030.myInfo.easyTicket": "خرید آسان بلیت هواپیما از تمامی خطوط هوایی با بهترین قیمت و بازگشت سود پرداخت به کیف پول شما",
  "7030.myInfo.easyShopping": "خرید آسان از مرکز خرید هفتادسی با بهترین قیمت و بازگشت سود پرداخت به کیف پول شما",
  "7030.myInfo.AddressData": "اطلاعات آدرس",
  "7030.myInfo.latinNameAndLastName": "نام و نام خانوادگی لاتین",
  "7030.myInfo.barCode": "بارکد",
  "7030.myInfo.drivingFine": "جریمه راهنمایی و رانندگی",
  "7030.ticket.airplane": "بلیت هواپیما",
  "7030.ticket.flightIn": "پرواز داخلی",
  "7030.ticket.flightOut": "پرواز خارجی",
  "7030.ticket.myTicket": "بلیت‌های من",
  "7030.ticket.roundTrip": "رفت و برگشت",
  "7030.ticket.went": "رفت",
  "7030.ticket.oneway": "رفت",
  "7030.ticket.sourceCity": "شهر مبدا",
  "7030.ticket.selectSourceCity": "انتخاب مبدا",
  "7030.ticket.targetCity": "شهر مقصد",
  "7030.ticket.selectTargetCity": "انتخاب مقصد",
  "7030.ticket.dateWent": "تاریخ رفت",
  "7030.ticket.dateRound": "تاریخ برگشت",
  "7030.ticket.dateWent&Round": "تاریخ رفت و برگشت",
  "7030.ticket.countAndTypePassenger": "تعداد و نوع مسافر",
  "7030.ticket.search": "جستجو",
  "7030.ticket.countAndTypePassengerSubject":
    "نوع و تعداد مسافران را انتخاب کنید",
  "7030.ticket.adultPassenger": "مسافر بزرگسال",
  "7030.ticket.adult": "بزرگسال",
  "7030.ticket.up12Age": "12 سال به بالا",
  "7030.ticket.childPassenger": "مسافر کودک",
  "7030.ticket.child": "کودک",
  "7030.ticket.up2Age": "2 تا 12 سال",
  "7030.ticket.infantPassenger": "مسافر نوزاد",
  "7030.ticket.infant": "نوزاد",
  "7030.ticket.low2Age": "زیر 2 سال",
  "7030.ticket.today": "امروز",
  "7030.ticket.fly": "پرواز",
  "7030.ticket.to": "به",
  "7030.ticket.select": "انتخاب بلیت",
  "7030.ticket.fnumber": "شماره پرواز",
  "7030.ticket.passengerInfo": "اطلاعات مسافران",
  "7030.ticket.edditPassengerInfo": "ویرایش اطلاعات مسافر",
  "7030.ticket.addPassenger": "افزودن مسافر جدید",
  "7030.ticket.addPassengerDesc": "اطلاعات مسافر رو وارد کنید",
  "7030.ticket.passengerDesc": "اطلاعات مسافر رو وارد کنید",
  "7030.ticket.gender": "جنسیت",
  "7030.ticket.man": "مرد",
  "7030.ticket.woman": "زن",
  "7030.ticket.birthday": "تاریخ تولد",
  "7030.ticket.finalTicket": "تایید نهایی خرید",
  "7030.ticket.clock": "ساعت",
  "7030.ticket.time": "زمان پرواز",
  "7030.ticket.showMore": "مشاهده جزئیات",
  "7030.ticket.closeShowMore": "بستن جزئیات",
  "7030.ticket.totalPrice": "مجموع مبلغ قابل پرداخت",
  "7030.ticket.ppPerfix": " با خرید این بلیت تمامی",
  "7030.ticket.ppSuffix": "سامانه هفتادسی را میپذیرم ",
  "7030.ticket.flightInfoPrice": "قیمت پرواز",
  "7030.ticket.flightInfo.0": "اطلاعات پرواز (پرواز رفت)",
  "7030.ticket.flightInfo.1": "اطلاعات پرواز (پرواز برگشت)",
  "7030.ticket.passengerInfo.0": "اطلاعات مسافرین (پرواز رفت)",
  "7030.ticket.passengerInfo.1": "اطلاعات مسافرین (پرواز برگشت)",
  "7030.ticket.notFound": "بلیتی یافت نشد",
  "7030.ticket.maxSelect": "حداکثر انتخاب شما برای مسافر",
  "7030.ticket.done": "می باشد",
  "7030.ticket.type": "نوع بلیت",
  "7030.ticket.capacity": "ظرفیت",
  "7030.ticket.cabinType": "نوع بلیت",
  "7030.ticket.seatClass": "کلاس پرواز",
  "7030.ticket.flightType": "نوع پرواز",
  "7030.ticket.airlineCodeName": "کد هواپیمایی",
  "7030.ticket.airplaneType": "نوع هواپیما",
  "7030.ticket.charter": "چارتر",
  "7030.ticket.system": "سیستمی",
  "7030.ticket.first-class-discounted": "فرست کلاس",
  "7030.ticket.economy-upgradable-to-business": "اکونومی",
  "7030.ticket.business": "بیزینس",
  "7030.ticket.business-discounted": "بیزینس ویژه",
  "7030.ticket.shuffle-service": "سرویس مختلط",
  "7030.ticket.first-class": "فرست کلاس",
  "7030.ticket.conditional-reservation": "قابل رزرو",
  "7030.ticket.business-premium": "پریمیوم",
  "7030.ticket.economy-discounted": "اکونومی ویژه",
  "7030.ticket.economy-discounted-upgradable-to-business": "اکونومی",
  "7030.ticket.first-class-premium": "فرست کلاس",
  "7030.ticket.first-class-supersonic-discontinued": "فرست کلاس",
  "7030.ticket.economy": "اکونومی",
  "7030.ticket.shuttle-service-no-reservation-needed-seat-guaranteed": "شاتل",
  "7030.ticket.economy-premium": "اکونومی",
  "7030.ticket.buyed": "آخرین خریدهای انجام شده:",
  "7030.ticket.reson": "دلیل استرداد خود را انتخاب کنید:",
  "7030.ticket.paymentWay": "لطفا روش پرداخت مبلغ استرداد شده را انتخاب کنید :",
  "7030.ticket.orderID": "شماره سفارش",
  "7030.ticket.notBuy": "هنوز بلیتی خریداری نکرده اید!",
  "7030.ticket.notBuyDesc":
    "بلیت‌های خریداری شده خود را در اینجا مشاهده می‌کنید.",
  "7030.ticket.dawn": "سحر",
  "7030.ticket.morning": "صبح",
  "7030.ticket.noon": "ظهر",
  "7030.ticket.evening": "عصر",
  "7030.ticket.night": "شب",
  "7030.ticket.flightTime": "ساعت پرواز",
  "7030.ticket.priceUp": "کمترین قیمت",
  "7030.ticket.priceDown": "بیشترین قیمت",
  "7030.ticket.filter": "فیلترها",
  "7030.ticket.resetFilter": "پیش فرض‌ها",
  "7030.ticket.buyTicketPage": "صفحه خرید بلیط",
  "7030.ticket.radio1": "دلایل شخصی",
  "7030.ticket.radio1-1": "استرداد بر اساس قوانین شرکت های هواپیمایی",
  "7030.ticket.radio2": "لغو پرواز توسط ایرلاین",
  "7030.ticket.radio3": "تاخیر یا تعجیل در پرواز بیش از دو ساعت",
  "7030.ticket.refundreason1": "PersonalReason",
  "7030.ticket.refundreason2": "ChangesOnScheduleMorethanTwoH",
  "7030.ticket.refundreason3": "FlightCancel",
  "7030.ticket.accept": "تایید",
  "7030.ticket.paymentw1": "شارژ اعتبار 7030",
  "7030.ticket.paymentw1Desc": "مبلغ مورد نظر حداکثر تا چهل و هشت ساعت دیگر به اعتبار شما در 7030 واریز خواهد شد.",
  "7030.ticket.paymentw2": "واریز به حساب بانکی",
  "7030.ticket.paymentw2Desc": "مبلغ مورد نظر شما حداکثر تا 7 روز کاری به حساب بانکی شما واریز خواهد شد.",
  "7030.ticket.paymentType2": "BankPayment",
  "7030.ticket.paymentType1": "Credit",


  "7030.startPage.income": "کسب درآمد",
  "7030.startPage.incomeText":
    "با هفتادسی میتونی سود کنی و با دعوت دیگران سودتو بیشتر کنی!",
  "7030.startPage.highSpeed": "خرید پرسرعت",
  "7030.startPage.highSpeedText":
    "با ذخیره تراکنش‌های پرتکرار با یک کلیک خرید کن!",
  "7030.startPage.services": "خدمات بی دردسر",
  "7030.startPage.servicesText":
    "کارای بانکیت، بیمه و خلافی ماشینت و خرید بلیت سفرت رو با هفتادسی راحت انجام بده.",
  "7030.startPage.prev": "قبلی",
  "7030.startPage.next": "بعدی",
  "7030.startPage.close": "بستن",
  "7030.startPage.enterApp": "ورود به اپلیکیشن",
  "7030.emptyState.noChargeSaved": "هنوز شارژ و بسته‌ای ذخیره نکرده‌اید!",
  "7030.emptyState.oneClickToCharge":
    "با ذخیره شارژ و بسته‌های پرتکرار خود با یک کلیک خرید کنید.",
  "7030.emptyState.noBillSaved": "هنوز قبضی ذخیره نکرده‌اید!",
  "7030.frequently.retryText": "خرید با یک کلیک",
  "7030.login.changeNumber": "تغییر شماره",
  "7030.login.waitAndEnterCode":
    "کمی شکیبا باشید و پس از دریافت، آن را وارد کنید.",
  "7030.login.otpCode": "کد تایید",
  "7030.login.wasSent": "فرستاده شد،",
  "7030.login.codeLength": "رقمی به شماره",
  "7030.login.aCode": "یک کد",
  "7030.login.sendCodeAgain": "ارسال مجدداً کد تایید",
  "7030.login.changePassword": "تغییر رمز عبور",
  "7030.login.newPassword": "رمز عبور جدید",
  "7030.login.repeatPassword": "تکرار رمز عبور",
  "7030.login.submitNewPassword": "ثبت رمز جدید",
  "7030.login.enteredValueIsNotSame": " * مقادیر وارد شده یکسان نیست!",
  "7030.login.enterAgainToMakeSure":
    "برای اطمینان رمز جدید را یک بار دیگر وارد کنید",
  "7030.login.makeANewPassword": "یک رمز جدید برای خود تعیین کنید",
  "7030.login.aFiveDigitsCode": "یک کد 5 رقمی به شماره",
  "7030.login.enterToaccountTitle": "ورود به حساب ",
  "7030.login.enterToaccount": "ورود به حساب کاربری",
  "7030.login.plsEnterYourPassword": "لطفاًً رمز عبور خود را وارد کنید:",
  "7030.login.enterPassWord": "رمز عبور را وارد کنید",
  "7030.login.forgotPassword": "رمز عبور را فراموش کرده‌ام",
  "7030.login.referId": " شناسه معرف",
  "7030.login.ifIntroduced": "اگر توسط شخصی به هفتادسی معرفی شدید،",
  "7030.login.bothGain": "شناسه معرف شخص رو وارد کنید و هر دو امتیاز بگیرید!",
  "7030.login.studyMore": "مطالعه بیشتر",
  "7030.login.enterReferId": "شناسه معرف خود را وارد کنید",
  "7030.login.submitReferId": "ثبت شناسه معرف",
  "7030.login.enterAfter": "بعداً وارد می‌کنم",
  "7030.insurance.insuranceService": "خدمات بیمه",
  "7030.insurance.buyInsurance": "خرید بیمه",
  "7030.insurance.myInsurance": "بیمه‌های من",
  "7030.insurance.recentlyPaid": "پرداختی اخیر",
  "7030.insurance.casualtyInsurance": "شخص ثالث",
  "7030.insurance.collisionInsurance": "بیمه بدنه",
  "7030.insurance.carUsage": "کاربری خودرو",
  "7030.insurance.car": "سواری",
  "7030.insurance.taxi": "تاکسی",
  "7030.insurance.agency": "آژانس",
  "7030.insurance.suburbanTaxi": "تاکسی برون شهری",
  "7030.insurance.clearanceDate": "تاریخ ترخیص خودرو",
  "7030.insurance.carInfo": "مشخصات خودرو",
  "7030.insurance.brandSelect": "انتخاب برند",
  "7030.insurance.carModel": "مدل خودرو",
  "7030.insurance.constructionYear": "سال",
  "7030.insurance.newCar": "خودرو صفر کیلومتر",
  "7030.insurance.hasPreviousInsurance": "خودرو دارای بیمه‌نامه قبلی",
  "7030.insurance.hasChangedOwnership": "خودرو تغییر مالکیت داشته",
  "7030.insurance.hasNotPreviousInsurance": "خودرو بدون بیمه‌نامه قبلی",
  "7030.insurance.carStatus": "وضعیت خودرو",
  "7030.insurance.insurance": "حق بیمه",
  "7030.insurance.maxCommitment": "سقف تعهدات",
  "7030.insurance.delayPenalty": "جریمه دیرکرد",
  "7030.insurance.validityDuration": "مدت اعتبار:",
  "7030.insurance.twelveMonth": "12 ماهه",
  "7030.insurance.insuranceInfo": "اطلاعات",
  "7030.insurance.usage": "کاربری",
  "7030.insurance.brand": "برند",
  "7030.insurance.model": "مدل",
  "7030.insurance.productionYear": "سال تولید",
  "7030.insurance.previousCompany": "شرکت بیمه‌گر قبلی",
  "7030.insurance.satrtDate": "تاریخ شروع بیمه‌نامه قبلی",
  "7030.insurance.expDate": "تاریخ اتمام بیمه‌نامه قبلی",
  "7030.insurance.thirdPartyDiscount": "تخفیف بیمه‌ ثالث قبلی",
  "7030.insurance.accidentDiscount": "تخفیف حوادث رانندگی قبلی",
  "7030.insurance.insurerProfile": "مشخصات بیمه‌گزار",
  "7030.insurance.Fname": "نام*",
  "7030.insurance.Lname": "نام‌خانوادگی*",
  "7030.insurance.dateOfBirth": "تاریخ تولد*",
  "7030.insurance.day": "روز",
  "7030.insurance.month": "ماه",
  "7030.insurance.year": "سال",
  "7030.insurance.nationalId": "کد ملی*",
  "7030.insurance.Email": "ایمیل",
  "7030.insurance.mobileNumber": "شماره تلفن همراه*",
  "7030.insurance.noteText":
    "لازم به ذکر است، شماره تلفن همراه باید به نام خود بیمه‌گذار باشد.",

  "7030.insurance.insuranceProfile": "مشخصات بیمه‌نامه",
  "7030.insurance.addressForInsurance": "آدرس جهت درج بر روی بیمه‌نامه*",
  "7030.insurance.uploadInsuranceDoc": "آپلود مدارک",
  "7030.insurance.carCardFront": "تصویر روی کارت ماشین یا برگ سبز",
  "7030.insurance.carCardBehind": "تصویر پشت کارت ماشین یا برگ سبز",
  "7030.insurance.previousInsurance": "تصویر بیمه‌نامه قبلی",
  "7030.insurance.drivingLicense": "تصویر روی کارت گواهینامه رانندگی",

  "7030.insurance.postInfo": "مشخصات ارسال",
  "7030.insurance.getElecVersion": "دریافت نسخه الکترونیک",
  "7030.insurance.getPaperVersion": "دریافت نسخه کاغذی",
  "7030.insurance.centeralInsuranceNote":
    "با توجه به بخش‌نامه بیمه مرکزی، همراه داشتن نسخه کاغذی بیمه شخص ثالث الزامی نمی‌باشد و پرداخت خسارت با نسخه الکترونیکی نیز انجام می‌گیرد",

  "7030.insurance.financialDamage": "خسارت مالی",
  "7030.insurance.lifeDamage": "خسارت جانی",
  "7030.insurance.driverDamage": "خسارت راننده",

  "7030.insurance.selectProvince": "انتخاب استان",
  "7030.insurance.selectCity": "انتخاب شهر",

  "7030.insurance.postId": "کدپستی*",
  "7030.insurance.addressToPost": "آدرس ارسال*",

  "7030.insurance.text":
    "بیمه شخص ثالث یکی از متداول‌ترین انواع بیمه محسوب می‌شود که داشتن آن برای صاحبان وسایل نقلیه اجباری است، بنابراین تمام وسایل نقلیه ملزم به داشتن بیمه ثالث هستند. شخص ثالث کسی است که در حوادث رانندگی متحمل زیان جانی یا مالی می‌شود. راننده مقصر لازم است تحت پوشش این بیمه قرار بگیرد تا هنگام وقوع حادثه شرکت بیمه خسارت وارد شده بر شخص ثالث را پرداخت کند.",
  "7030.insurance.Sectext":
    "شخص ثالث کسی است که در حوادث رانندگی متحمل زیان جانی یا مالی می‌شود. راننده مقصر لازم است تحت پوشش این بیمه قرار بگیرد تا هنگام وقوع حادثه شرکت بیمه خسارت وارد شده بر شخص ثالث را پرداخت کند",
  "7030.insurance.carBodyText":
    "بیمه بدنه به نوعی از بیمه گفته می‌شود که خسارت‌های وارد شده بر خودرو را جبران می‌کند. خرید بیمه بدنه خودرو اجباری نیست اما این نوع بیمه پوشش‌هایی را شامل می‌شود که داشتن آن برای صاحبان خودرو مزیت‌های فراوانی به همراه دارد.",

  "7030.insurance.transportation": "ایاب و ذهاب",
  "7030.insurance.naturalDisasters": "حوادث طبیعی",
  "7030.insurance.breakingGlass": "شکست شیشه",
  "7030.insurance.sprayingChemicals": "پاشیدن مواد شیمیایی",
  "7030.insurance.valueFluctuations": "نوسانات ارزش",
  "7030.insurance.onSiteTheftOfParts": "سرقت در جا قطعات",
  "7030.insurance.haveNotNonFabricAccessories": "لوازم غیر فابریک ندارم",
  "7030.insurance.noNoneFabricAccessories": "فاقد لوازم غیر فابریک",
  "7030.insurance.valueOfNoneFabricAccessories": "ارزش لوازم غیر فابریک",
  "7030.insurance.clickOnHaveNoneFabricAccessories": "درصورت نداشتن لوازم غیرفابریک روی گزینه لوازم غیرفابریک ندارم کلیک کنید!",
  "7030.insurance.minimumValueOfCar": "حداقل ارزش خودرو 50 میلیون تومان",
  "7030.insurance.valueOfCar": "ارزش خودرو",
  "7030.insurance.yearOfCarProduction": "سال تولید خودرو",
  "7030.insurance.carBrand": "برند خودرو",
  "7030.insurance.carProduction": "تولید خودرو",
  "7030.insurance.imported": "وارداتی",
  "7030.insurance.internal": "داخلی",
  "7030.insurance.yearOfInsuranceDiscount": "سال تخفیف عدم خسارت بیمه ثالث",
  "7030.insurance.alreadyHasInsurance": "دارای بیمه‌نامه قبلی",
  "7030.insurance.doNotHaveInsurance": "بیمه نداشته",
  "7030.insurance.hasInsurance": "بیمه داشته",
  "7030.insurance.yearOfCarBodyDiscount": "سال تخفیف عدم خسارت بیمه بدنه",
  "7030.insurance.damageIncreasement": "افزایش میزان خسارت پرداختی توسط شرکت بیمه در صورت افزایش قیمت روز خودرو",
  "7030.insurance.nothing": "هیچکدام",
  "7030.insurance.coverageOfCarAccessories": "پوشش جهت جبران خسارت ناشی از سرقت لوازم خودرو",
  "7030.insurance.monthOfCarProduction": "ماه تولید خودرو",
  "7030.insurance.selectDeliveryTime": "انتخاب بازه زمانی ارسال",

  "7030.insurance.selectPaymentGate": "درگاه پرداخت را انتخاب کنید.",
  "7030.insurance.readTheRulesAndAgree": "را خوانده‌ام و تأیید می‌کنم.",
  "7030.insurance.payableAmount": "مبلغ قابل پرداخت",
  "7030.insurance.totalDiscount": "مجموع تخفیف",

  "7030.insurance.ninePercentTax": "۹ درصد مالیات بر ارزش افزوده",
  "7030.insurance.finalInsurance": "حق بیمه نهایی",
  "7030.insurance.baseInsurance": "حق بیمه پایه",
  "7030.insurance.insuranceDuration": "مدت زمان بیمه",
  "7030.insurance.netPremium": "حق بیمه خالص",
  "7030.insurance.finalInsurancePremium": "حق بیمه نهایی",

  "7030.insurance.imageOfPreviousthirdPartyInsurance": "تصویر بیمه شخص ثالث قبلی",
  "7030.insurance.levelOfFinancialWealth": "سطح توانگری مالی",
  "7030.insurance.insuranceBaseCost": "مبلغ پایه بیمه",
  "7030.insurance.marketShare": "سهم از بازار",
  "7030.insurance.insuranceDiscountAmount": "مبلغ تخفیف بیمه",
  "7030.insurance.customerSatisfacation": "رضایت مشتری",
  "7030.insurance.compensationCenters": "تعداد مراکز پرداخت خسارت",
  "7030.insurance.durationOfRespondingTocomplaint": "مدت زمان پاسخگویی به شکایت",
  "7030.insurance.insuranceNotFound": "بیمه‌ای با مشخصات وارد شده پیدا نشد",
  "7030.insurance.noInsuranceYet": "هنوز بیمه‌ای خریداری نکرده‌اید",

  "7030.insurance.goToinusurancePurchase": "برای مشاهده بیمه و خرید آن به قسمت خرید بیمه مراجعه کنید.",
  "7030.insurance.body": "بدنه",
  "7030.insurance.maximumFinancialCommitment": "حداکثر تعهد مالی",
  "7030.insurance.policyTerm": "مدت بیمه‌نامه",
  "7030.insurance.insurancePremium": "حق بیمه",
  "7030.insurance.insuranceName": "نام بیمه",

  "7030.insurance.noPaymentYet": "شما هیچ پرداختی نداشته‌اید",
};
